import { Filter, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';

const JigsawGameFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" alwaysOn />
    <TextInput label="Jigsaw game ID" source="jigsaw_event_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="from" end alwaysOn />
    <CustomDateInput label="Choose end date" source="to" end alwaysOn />
  </Filter>
);

export default JigsawGameFilter;
